import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-el-three",
  "use": "icon-el-three-usage",
  "viewBox": "0 0 128 128",
  "content": "<symbol viewBox=\"0 0 128 128\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-el-three\">\n<rect x=\"13\" y=\"13.5\" width=\"24\" height=\"100\" rx=\"10\" />\n<rect x=\"52\" y=\"13.5\" width=\"24\" height=\"100\" rx=\"10\" />\n<rect x=\"91\" y=\"13.5\" width=\"24\" height=\"100\" rx=\"10\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol